import dayjs from 'dayjs';

const LUCKY_BONUS_PACK_START = '2026-04-01T00:00:00.000+09:00';
const LUCKY_BONUS_PACK_END = '2026-04-30T23:59:59.999+09:00';

/**
 * 4월 행운보너스팩 이벤트가 진행중인지 판별하는 유틸 함수
 */
export const getIsLuckyBonusPackEventPeriod = () => {
  const now = dayjs();
  return (
    now.isAfter(dayjs(LUCKY_BONUS_PACK_START)) &&
    now.isBefore(dayjs(LUCKY_BONUS_PACK_END))
  );
};

export const getBonusPackCouponAmountText = (): string =>
  getIsLuckyBonusPackEventPeriod() ? '3만원' : '2만원';
